import API_BASE_URL from "../../../../../../Constants";

// function to fetch PVR ID/Label options for dropdowns
export const fetchPVROptions = async () => {
  const response = await fetch(
    `${API_BASE_URL}/api/violations/violation-options`,
    {
      method: "GET",
      credentials: "include",
    }
  );
  // Check if the response is ok and return the JSON data
  if (response.ok) {
    return await response.json();
  }
  // If the response is not ok, log the error and return null
  console.error("Failed to fetch violation options:", response.statusText);
  return null;
};
